module.exports = __webpack_public_path__ + "static/media/background-forwardslash2.20b1a591.svg";